import React, {useContext} from 'react';

export enum RenderContext {
  ProductPage = 'productPage',
  StickyDrawer = 'stickyDrawer',
}

export const RenderContextContext = React.createContext<RenderContext>(RenderContext.ProductPage);

export const useRenderContext = () => useContext(RenderContextContext);
export const RenderContextProvider = RenderContextContext.Provider;

export function useIsRenderedFrom(context: RenderContext): boolean {
  return useRenderContext() === context;
}

export const useIsStickyButton = (): boolean => useIsRenderedFrom(RenderContext.StickyDrawer);

export type WithRenderContextProps = {
  renderContext?: RenderContext;
};

export function withRenderContext<P extends WithRenderContextProps>(
  Component: React.ComponentType<P>
): React.ComponentType<Omit<P, 'renderContext'>> {
  return (props: Omit<P, 'renderContext'>) => {
    const renderContext = useRenderContext();
    return <Component {...(props as P)} renderContext={renderContext} />;
  };
}
